<template>
    <BreadCrumb PageTitle="Modifier une validation Check" />
    <EditValidationCheck />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditValidationCheck from "@/components/ValidationCheck/EditValidationCheck.vue";

export default defineComponent({
    name: "EditValidationCheckPage",
    components: {
        BreadCrumb,
        EditValidationCheck,
    },
});
</script>